const id_master_profile = {
    "": "profil",
    add: "tambah profil",
    edit: "ubah profil",

    form: {

    },

    error: {
        name: "Nama profil tidak boleh kosong.",
        menu_list: "Minimal terdapat 1 akses menu.",
        menu_list_min: "Minimal terdapat 1 item akun untuk membuat menu.",
        create: "Gagal membuat profil.",
        delete: "Gagal menghapus profil.",
        edit: "Gagal mengubah profil.",
    },

    success: {
        create: "Berhasil membuat profil.",
        delete: "Berhasil menghapus profil.",
        edit: "Berhasil mengubah profil.",
    },
}

export default id_master_profile;